
const initialState = {
	user: null
};

export default (state = initialState) => state;
